import { render, staticRenderFns } from "./ReviewPage8.vue?vue&type=template&id=690f6324&"
import script from "./ReviewPage8.vue?vue&type=script&lang=js&"
export * from "./ReviewPage8.vue?vue&type=script&lang=js&"
import style0 from "./ReviewPage8.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports